import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form, Row, Col, FormGroup, Input, Label } from "reactstrap";
import withRedirect from "../../hoc/withRedirect";
import AuthService from "../../services/authenticationService";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import AppContext from "../../context/Context";
import bgImage from "../../assets/img/logos/api-award-2022.jpg";
import Divider from "../common/Divider";
import APIReference from "../../assets/img/logos/login/API_Ref.png";
import APIStatus from "../../assets/img/logos/login/API_Status.png";
import FAQ from "../../assets/img/logos/login/FAQs1.png";
import Avatar from "../common/Avatar";
import AuthCardLayout from "./AuthCardLayout";
import { detect } from "detect-browser";
import authHeader from "../../services/authenticationHeader";
import axios from "axios";
import apiURL from "../../services/apiURL";
import { ip } from "../../services/apiCall";

const browser = detect();
const API_URL = apiURL();

const PMSesLogin = ({ setRedirect, hasLabel, setRedirectUrl }) => {
  const { setRemember } = useContext(AppContext);

  const [email, setEmail] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [verificationCodeSentBoolean, setVerificationCodeSentBoolean] = useState(false);
  const [accessCode, setAccessCode] = useState("");

  useEffect(() => {
    if (localStorage.getItem("remember")) {
      setRemember(true);
    }
  }, []);

  const postVisitLogs = () => {
    const body = {
      dev_id: "",
      email_id: email,
      dev_name: email,
      is_admin: "yes",
      app_id: "",
      page_name: "PMSes-Login",
      action_name: "PMSes-Login",
      project_name: "API Portal v4.0",
      ip_address: ip ? ip : "",
      browser_name: `${browser?.name.charAt(0).toUpperCase() + browser?.name.slice(1)}`,
      browser_version: `${browser?.version}`,
      extra_comment: "Accessing PMSes supported documentation page",
      host_name: `${window.location.hostname}`,
    };

    axios
      .post(API_URL + "visit", body, { withCredentials: true })
      .then(() => {})
      .catch(() => {
        // localStorage.removeItem("actn");
        // localStorage.removeItem("lngst");
        // localStorage.removeItem("tempData");
        // window.location.assign(`${process.env.PUBLIC_URL}/authentication/login`);
      });
  };

  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const handleSendAccessCode = (e) => {
    setIsDisabled(true);
    e.preventDefault();
    showLoader();
    AuthService.PMSesLogin(email).then(
      (res) => {
        setVerificationCodeSentBoolean(true);
        toast.success(`Verification Code successfully sent to ${email}`);
        setIsDisabled(false);
        hideLoader();
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        hideLoader();
        setVerificationCodeSentBoolean(false);
        setIsDisabled(false);
        toast.error(resMessage);
      }
    );
  };

  const handleAccessCodeVerification = (e) => {
    e.preventDefault();
    setIsDisabled(true);
    showLoader();
    AuthService.PMSesAccessCodeVerification(accessCode, email).then(
      (res) => {
        toast.success("Welcome to PMSes supported documentation!");
        setIsDisabled(false);
        postVisitLogs();
        hideLoader();
        setRedirectUrl(`${process.env.PUBLIC_URL}/documentation/pmses-supported`);
        setRedirect(true);
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        hideLoader();
        setIsDisabled(false);
        toast.error(resMessage);
      }
    );
  };

  return (
    <AuthCardLayout bgProps={{ image: bgImage }}>
      <Row className="justify-content-center mb-4">
        <Col>
          <h5 className="d-flex justify-content-center fs-2">PMSes Log in</h5>
        </Col>
      </Row>
      {verificationCodeSentBoolean ? (
        <Form onSubmit={handleAccessCodeVerification}>
          <FormGroup>
            {hasLabel && <Label>Access Code</Label>}
            <Input
              value={accessCode}
              placeholder={!hasLabel ? "Access Code" : ""}
              onChange={({ target }) => setAccessCode(target.value)}
              type="text"
            />
          </FormGroup>

          <FormGroup>
            <Button color="primary" block className="mt-3" disabled={isDisabled}>
              Verify
            </Button>
          </FormGroup>
        </Form>
      ) : (
        <Form onSubmit={handleSendAccessCode}>
          <FormGroup>
            {hasLabel && <Label>Email address</Label>}
            <Input
              value={email}
              placeholder={!hasLabel ? "Email address" : ""}
              onChange={({ target }) => setEmail(target.value)}
              type="email"
            />
          </FormGroup>

          <FormGroup>
            <Button color="primary" block className="mt-3" disabled={isDisabled}>
              Get the Access Code
            </Button>
          </FormGroup>
        </Form>
      )}
      <Divider className="mt-4" />
      {loader}
      <Row>
        <Row className="g-4 text-center text-md-start d-flex justify-content-center mt-4">
          <Col>
            <Link
              className="text-decoration-underline text-white fs--1"
              to={{ pathname: "https://apidocs.sikkasoft.com/" }}
              target="_blank"
            >
              <Col>
                <Avatar rounded={false} size="3xl" src={APIReference} />
                <h6 className="fs--1 text-800 fw-normal mb-3">API Reference</h6>
              </Col>
            </Link>
          </Col>
          <Col>
            <Link
              className="text-decoration-underline text-white fs--1"
              to={{ pathname: "https://apidocs.sikkasoft.com/" }}
              target="_blank"
            >
              <Col>
                <Avatar rounded={false} size="3xl" src={APIStatus} />
                <h6 className="fs--1 text-800 fw-normal mb-3">API Status</h6>
              </Col>
            </Link>
          </Col>
          <Col>
            <Link
              className="text-decoration-underline text-white fs--1"
              to={{ pathname: "https://apidocs.sikkasoft.com/" }}
              target="_blank"
            >
              <Col>
                <Avatar rounded={false} size="3xl" src={FAQ} />
                <h6 className="fs--1 text-800 fw-normal mb-3">FAQs</h6>
              </Col>
            </Link>
          </Col>
        </Row>
      </Row>
    </AuthCardLayout>
  );
};

PMSesLogin.propTypes = {
  setRedirect: PropTypes.func.isRequired,
  layout: PropTypes.string,
  hasLabel: PropTypes.bool,
  setRedirectUrl: PropTypes.func.isRequired,
};

PMSesLogin.defaultProps = {
  hasLabel: false,
};

export default withRedirect(PMSesLogin);
